import { call, put, takeLatest } from "redux-saga/effects";
import { fetchAllFaculties } from "../../../services/faculty";
import {
  getFacultiesFailure,
  getFacultiesStart,
  getFacultiesSuccess,
} from "../reducer";

export function* getAllFaculty({ payload }) {
  const response = yield call(fetchAllFaculties, payload);
  const { success, raw, message } = response;

  if (success) {
    yield put(getFacultiesSuccess(raw));
  } else {
    yield put(getFacultiesFailure(message || raw.error));
  }
}

export default function* onGetAllFaculty() {
  yield takeLatest(getFacultiesStart.type, getAllFaculty);
}
